/*
  Valcairn Quote List v4
  Front-end project inquiry storage. This is not Shopify's native cart and does not collect payment.
*/
(function () {
  var KEY = 'valcairn_project_cart_v1';
  var LEGACY_KEYS = ['valcairn_project_cart', 'valcairn_project_items'];
  var INQUIRY_URL = '/pages/request-a-quote';
  var initialized = false;

  function canStore() {
    try {
      var test = '__valcairn_project_cart_test__';
      window.localStorage.setItem(test, test);
      window.localStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }

  function safeParse(value) {
    try { return JSON.parse(value); } catch (error) { return null; }
  }

  function normalizeHandle(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  }


  function inferItemCategory(item) {
    item = item || {};
    var text = [item.projectCategory, item.project_category, item.title, item.product_title, item.product, item.name, item.handle, item.product_handle, item.collection, item.collection_title, item.type, item.source, item.notes, item.note].join(' ').toLowerCase();
    if (/hood|range|ventilation|cooktop/.test(text)) return 'hoods';
    if (/bath|sink|basin|tub|vanity|powder|shower/.test(text)) return 'bath';
    if (/table|object|plinth|pedestal|bench|console|furniture/.test(text)) return 'objects';
    if (/opening|door|window|arch|niche|mirror|wall panel|portal/.test(text)) return 'openings';
    if (/mantel|hearth|firebox|overmantel|fireplace|chimney/.test(text)) return 'mantels';
    if (/fountain|facade|façade|sculpt|floor|paver|paving|coping|threshold|exterior|garden|custom|not sure|other/.test(text)) return 'other';
    return '';
  }

  function isInquiryPage() {
    var path = window.location.pathname || '';
    return path.indexOf('/pages/request-a-quote') > -1 || path.indexOf('/pages/design-inquiry') > -1;
  }

  function read() {
    if (!canStore()) return [];
    var raw = safeParse(window.localStorage.getItem(KEY));
    var items = Array.isArray(raw) ? raw : [];

    if (!items.length) {
      LEGACY_KEYS.forEach(function (legacyKey) {
        var legacy = safeParse(window.localStorage.getItem(legacyKey));
        if (!legacy) return;
        if (Array.isArray(legacy)) {
          legacy.forEach(function (item) { items.push(normalizeItem(item)); });
        } else {
          items.push(normalizeItem(legacy));
        }
      });
      items = dedupe(items);
      if (items.length) write(items, { silent: true });
    }

    return dedupe(items.map(normalizeItem));
  }

  function write(items, options) {
    if (!canStore()) return [];
    var normalized = dedupe((Array.isArray(items) ? items : []).map(normalizeItem));
    window.localStorage.setItem(KEY, JSON.stringify(normalized));
    window.localStorage.setItem('valcairn_project_cart', JSON.stringify(normalized));

    if (!options || !options.silent) {
      var event;
      try {
        event = new CustomEvent('valcairn:project-cart-updated', { detail: { items: normalized } });
      } catch (error) {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('valcairn:project-cart-updated', true, true, { items: normalized });
      }
      window.dispatchEvent(event);
      document.dispatchEvent(event);
    }

    updateHeaderCta(normalized);
    renderPersistentBar(normalized);
    return normalized;
  }

  function normalizeItem(item) {
    item = item || {};
    var title = item.title || item.product_title || item.product || item.name || item.type || 'Quote item';
    var handle = item.handle || item.product_handle || normalizeHandle(title);
    var selectedStoneHandle = item.selectedStoneHandle || item.selected_stone_handle || item.material_handle || normalizeHandle(item.selectedStoneTitle || item.material || item.selected_material || '');
    var id = item.id || [item.type || 'catalog_product', handle, selectedStoneHandle || 'by-quote'].join('::');

    return {
      id: String(id),
      type: item.type || item.source || 'catalog_product',
      title: String(title),
      handle: String(handle || ''),
      url: item.url || item.product_url || (handle ? '/products/' + handle : ''),
      image: item.image || item.product_image || '',
      sku: item.sku || item.model || item.product_sku || '',
      collection: item.collection || item.collection_title || '',
      selectedStoneTitle: item.selectedStoneTitle || item.selected_stone_title || item.material || item.selected_material || '',
      selectedStoneHandle: selectedStoneHandle || '',
      selectedStoneImage: item.selectedStoneImage || item.selected_stone_image || item.material_image || '',
      selectedProductImage: item.selectedProductImage || item.selected_product_image || item.image || '',
      size: item.size || item.width || '',
      quantity: Number(item.quantity || 1),
      notes: item.notes || item.note || item.description || '',
      projectCategory: (item.projectCategory || item.project_category || inferItemCategory(item) || '').replace('custom','other'),
      addedAt: item.addedAt || new Date().toISOString()
    };
  }

  function dedupe(items) {
    var seen = {};
    return (items || []).filter(function (item) {
      if (!item) return false;
      var key = item.id || [item.type, item.handle, item.selectedStoneHandle].join('::');
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function add(item) {
    var items = read();
    var normalized = normalizeItem(item);
    var replaced = false;

    items = items.map(function (existing) {
      if (existing.id === normalized.id) {
        replaced = true;
        return Object.assign({}, existing, normalized, { addedAt: new Date().toISOString() });
      }
      return existing;
    });

    if (!replaced) items.push(normalized);
    return write(items);
  }

  function remove(id) {
    return write(read().filter(function (item) { return item.id !== id; }));
  }

  function clear() {
    return write([]);
  }

  function count() {
    return read().length;
  }

  function extractProductItem(button) {
    var section = button.closest('[data-vpc-product-detail]') || button.closest('.vpd') || button.closest('[data-product-handle]');
    if (!section) return null;

    var mainImage = section.querySelector('.vpd-main-image, [data-vpc-main-image]');
    var activeMaterial = section.querySelector('[data-vpd-material].is-active, [data-vpc-material].is-active');
    var selectedSize = section.querySelector('[data-vpd-size].is-active, [data-vpc-size].is-active');

    var h1 = document.querySelector('h1');
    var title = section.dataset.productTitle || section.dataset.title || (h1 && h1.textContent ? h1.textContent.trim() : '') || 'Valcairn product';
    var handle = section.dataset.productHandle || normalizeHandle(title);
    var stoneTitle = activeMaterial ? (activeMaterial.dataset.vpdMaterialLabel || activeMaterial.dataset.vpcMaterialLabel || activeMaterial.getAttribute('title') || activeMaterial.textContent.trim()) : '';
    var stoneHandle = activeMaterial ? (activeMaterial.dataset.vpdMaterialHandle || activeMaterial.dataset.vpcMaterialHandle || normalizeHandle(stoneTitle)) : '';
    var stoneImage = '';

    if (activeMaterial) {
      var stoneImg = activeMaterial.querySelector('img');
      stoneImage = activeMaterial.dataset.vpdMaterialImage || activeMaterial.dataset.vpcMaterialImage || (stoneImg ? (stoneImg.currentSrc || stoneImg.src || '') : '');
    }

    var productImage = mainImage ? (mainImage.currentSrc || mainImage.src || '') : (section.dataset.productImage || '');
    var originalImage = section.dataset.productImage || productImage;

    return normalizeItem({
      id: ['catalog_product', handle, stoneHandle || 'by-quote'].join('::'),
      type: 'catalog_product',
      title: title,
      handle: handle,
      url: section.dataset.productUrl || (handle ? '/products/' + handle : window.location.pathname),
      image: originalImage,
      selectedProductImage: productImage,
      sku: section.dataset.productSku || section.dataset.sku || '',
      collection: section.dataset.productCollection || section.dataset.collectionTitle || '',
      selectedStoneTitle: stoneTitle,
      selectedStoneHandle: stoneHandle,
      selectedStoneImage: stoneImage,
      size: selectedSize ? (selectedSize.dataset.vpdSizeLabel || selectedSize.dataset.vpcSizeLabel || selectedSize.textContent.trim()) : '',
      quantity: 1
    });
  }

  function setButtonFeedback(button) {
    if (!button) return;
    if (!button.dataset.vpcOriginalText) button.dataset.vpcOriginalText = button.textContent.trim() || 'Save for Quote';
    button.textContent = 'Saved for Quote';
    button.classList.add('is-added-to-project');
    window.setTimeout(function () {
      button.textContent = button.dataset.vpcOriginalText;
      button.classList.remove('is-added-to-project');
    }, 1800);
  }

  function renderPersistentBar(items, options) {
    items = Array.isArray(items) ? items : read();
    var existing = document.querySelector('[data-vpc-persistent-bar]');
    var itemCount = items.length;

    document.body.classList.toggle('vpc-has-project-bar', itemCount > 0 && !isInquiryPage());

    if (!itemCount || isInquiryPage()) {
      if (existing) existing.remove();
      return;
    }

    var latest = items[items.length - 1] || items[0];
    var title = latest ? latest.title : 'Quote item';
    var stone = latest && latest.selectedStoneTitle ? latest.selectedStoneTitle : '';
    var label = itemCount === 1 ? '1 model saved' : itemCount + ' models saved';

    if (!existing) {
      existing = document.createElement('aside');
      existing.setAttribute('data-vpc-persistent-bar', '');
      existing.className = 'vpc-project-bar';
      existing.setAttribute('aria-live', 'polite');
      document.body.appendChild(existing);
    }

    existing.innerHTML = '' +
      '<div class="vpc-project-bar__content">' +
        '<div class="vpc-project-bar__kicker">Quote request</div>' +
        '<div class="vpc-project-bar__title">' + escapeHtml(label) + '</div>' +
        '<div class="vpc-project-bar__detail">' + escapeHtml(title) + (stone ? ' · ' + escapeHtml(stone) : '') + '</div>' +
      '</div>' +
      '<a class="vpc-project-bar__action" data-vpc-review-inquiry href="' + INQUIRY_URL + '">Review quote request (' + itemCount + ')</a>';

    if (options && options.highlight) {
      existing.classList.remove('is-highlighted');
      void existing.offsetWidth;
      existing.classList.add('is-highlighted');
      window.setTimeout(function () { existing.classList.remove('is-highlighted'); }, 1200);
    }
  }

  function showToast(item, items) {
    renderPersistentBar(items, { highlight: true });
  }

  function updateHeaderCta(items) {
    items = Array.isArray(items) ? items : read();
    var itemCount = items.length;
    var candidates = [];
    var headerScopes = document.querySelectorAll('.shopify-section-group-header-group, .shopify-section--header, header, .header, #shopify-section-header');

    headerScopes.forEach(function (scope) {
      scope.querySelectorAll('[data-vpc-header-cta], a[href*="/pages/request-a-quote"], a[href*="request-quote"], a.valcairn-header__cta-link, summary.valcairn-header__cta-link').forEach(function (el) {
        candidates.push(el);
      });
    });

    candidates = candidates.filter(function (el, index, array) { return array.indexOf(el) === index; });

    candidates.forEach(function (el) {
      if (!el.dataset.vpcOriginalText) el.dataset.vpcOriginalText = el.getAttribute('data-vpc-empty-label') || el.textContent.trim() || 'Request Quote';
      var nextLabel = itemCount ? ('Review Quote Request (' + itemCount + ')') : el.dataset.vpcOriginalText;
      el.textContent = nextLabel;
      el.setAttribute('aria-label', nextLabel);
      el.classList.toggle('has-project-items', itemCount > 0);
      if (el.tagName.toLowerCase() === 'a') el.setAttribute('href', INQUIRY_URL);
    });

    renderPersistentBar(items);
  }

  function bindAddButtons() {
    document.querySelectorAll('[data-vpc-add-product]').forEach(function (button) {
      if (button.dataset.vpcBound === 'true') return;
      button.dataset.vpcBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var item = extractProductItem(button);
        if (!item) return;
        var items = add(item);
        setButtonFeedback(button);
        showToast(item, items);
      });
    });
  }

  function bindCartLinks() {
    document.querySelectorAll('[data-vpc-review-inquiry]').forEach(function (link) {
      if (link.dataset.vpcBound === 'true') return;
      link.dataset.vpcBound = 'true';
      link.addEventListener('click', function () { updateHeaderCta(read()); });
    });
  }

  function injectStyles() {
    if (document.getElementById('valcairn-project-cart-styles')) return;
    var style = document.createElement('style');
    style.id = 'valcairn-project-cart-styles';
    style.textContent = '\n' +
      '.vpc-project-bar{position:fixed;right:22px;bottom:22px;z-index:80;display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:stretch;max-width:min(560px,calc(100vw - 44px));border:1px solid rgba(27,25,22,.18);background:#f6f2ea;color:#1b1916;box-shadow:0 22px 60px rgba(27,25,22,.20);font-family:inherit;transform:translateY(0);transition:transform .26s ease,box-shadow .26s ease,border-color .26s ease}.vpc-project-bar.is-highlighted{box-shadow:0 24px 72px rgba(27,25,22,.26);border-color:rgba(27,25,22,.38);transform:translateY(-4px)}.vpc-project-bar__content{min-width:0;padding:16px 18px 15px}.vpc-project-bar__kicker{margin:0 0 5px;font-size:10px;line-height:1.1;letter-spacing:.18em;text-transform:uppercase;color:#7c7468}.vpc-project-bar__title{font-size:14px;line-height:1.3;font-weight:500;letter-spacing:.02em}.vpc-project-bar__detail{margin-top:3px;max-width:330px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#6d675d;font-size:13px;line-height:1.4}.vpc-project-bar__action{display:flex;align-items:center;justify-content:center;min-width:180px;padding:0 18px;background:#191816;color:#fff;text-decoration:none;text-transform:uppercase;letter-spacing:.13em;font-size:11px;line-height:1.15;text-align:center}.vpc-project-bar__action:hover{background:#4a4339;color:#fff}.is-added-to-project{opacity:.82}.valcairn-header__cta-link.has-project-items{background:#4a4339!important;border-color:#4a4339!important;color:#fff!important}.valcairn-header__cta-link.has-project-items::after{content:\'\';display:inline-block;width:6px;height:6px;margin-left:9px;border-radius:999px;background:currentColor;opacity:.85}@media(max-width:699px){body.vpc-has-project-bar{padding-bottom:calc(86px + env(safe-area-inset-bottom,0px))}.vpc-project-bar{left:12px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom,0px));max-width:none;grid-template-columns:1fr;box-shadow:0 18px 50px rgba(27,25,22,.28)}.vpc-project-bar__content{padding:13px 14px 10px}.vpc-project-bar__detail{max-width:100%}.vpc-project-bar__action{min-width:0;min-height:44px;padding:0 14px}}@media(prefers-reduced-motion:reduce){.vpc-project-bar{transition:none}.vpc-project-bar.is-highlighted{transform:none}}';
    document.head.appendChild(style);
  }

  function init() {
    injectStyles();
    bindAddButtons();
    bindCartLinks();
    updateHeaderCta(read());
  }

  window.ValcairnProjectCart = {
    read: read,
    write: write,
    add: add,
    remove: remove,
    clear: clear,
    count: count,
    updateHeaderCta: updateHeaderCta,
    renderPersistentBar: renderPersistentBar
  };

  if (!initialized) {
    initialized = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
    window.addEventListener('pageshow', function () { updateHeaderCta(read()); });
    window.addEventListener('storage', function (event) {
      if (event.key === KEY || LEGACY_KEYS.indexOf(event.key) > -1) updateHeaderCta(read());
    });
    window.addEventListener('valcairn:project-cart-updated', function (event) {
      updateHeaderCta(event.detail && event.detail.items ? event.detail.items : read());
    });
  }
})();
